import React, { useEffect, useState } from 'react'
import MasterPage from 'components/MasterPage'
import { api } from 'services'
import { Row, Card, Col, Button, Spinner, Table } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { DashboardOutlined } from '@material-ui/icons'
import ListingReportsActions from 'components/ListingReportsActions'
import convertToAscii from 'helpers/ConvertToASCII'
import ReactDOMServer from 'react-dom/server'
import { Link } from 'react-router-dom'

const Actions = () => {
  const defaultFilters = {
    __search: '',
    per_page: 10,
    page: 1,
    __fiscal_year: '',
    __task_id: '',
    __status_id: ''
  };

  const [filters, setFilters] = useState(defaultFilters)
  const [actions, setActions] = useState([])
  const [pagination, setPagination] = useState({})
  const [fiscalYears, setFiscalYears] = useState([])
  const [load, setLoad] = useState(true)
  const [isExport, setIsExport] = useState(false)
  const [taskGroups, setTaskGroups] = useState([])
  const [statusList, setStatusList] = useState([])

	const { t } = useTranslation();

  const handleFilterChange = (new_filters, reset = false) => {
    let f = { ...filters, ...new_filters }
    if (reset) f = { ...defaultFilters, ...new_filters }
    setFilters(f);
  };

  const colConfig = {
    headerStyle: {
      width: '4%',
      textAlign: 'center'
    },
    style: {
      textAlign: 'center',
      fontSize: '15px'
    }
  }

  const columns = [
    {
      dataField: 'id',
      text: 'ID',
      ...colConfig
    },
    {
      dataField: 'manufacturer',
      text: 'Fabricante',
      ...colConfig
    },
    {
      dataField: 'task_name',
      text: 'Atividade',
      ...colConfig
    },    
    {
      dataField: 'status',
      text: 'Status',
      ...colConfig
    },
    {
      dataField: 'action_value',
      text: 'Valor', // Action value
      ...colConfig
    },
    {
      dataField: 'expected_value',
      text: 'Gasto Previsto', // Expense Expected
      ...colConfig
    },
    {
      dataField: 'real_value',
      text: 'Gasto Real',
      ...colConfig
    },
    {
      dataField: 'expire_fund',
      text: 'Verba Expirada', // Expire
      ...colConfig
    },
    {
      dataField: 'margin',
      text: 'Margem', // Margin Expected
      ...colConfig
    }
  ];

  useEffect(() => {
    getActions()    
  }, [filters])

  useEffect(() => {    
    getFiscalYears()
    fetchTasks()
    fetchStatusList()
  },[])

  const getActions = async () => {
    const { data: response } = await fetchActions(filters)
    const { data, pagination } = response

    setActions(formatData(data))
    setPagination(pagination)
  }

  const fetchActions = (_filters) => {
    return api.get('report-actions', {
      params: { ..._filters }
    })
  }

  const fetchTasks = () => {
    return api.get('task-groups/list-for-action')
    .then(({ data }) => setTaskGroups(data))
  }

  const fetchStatusList = () => {
    api.get('actions/status')
    .then(({ data }) => {
      console.log(data)
      setStatusList(data);
    });
  }

  const formatData = (arr, isExport = false) => {
    const formatValue = value => {
      return value.toLocaleString('pt-br', {
        style: 'currency',
        currency: 'BRL',
      })
    }

    const buildActionLink = id => {
      return (
        <Link to={`/actions/edit/${id}`} >
          {id}
        </Link>
      )
    }

    return arr.map((action) => {
      return {
        id: !isExport ? buildActionLink(action.id) : action.id,
        manufacturer: action.company_name,
        task_name: action.task_name,
        status: t(`statuses:${action.status}`),
        action_value: formatValue(action.margin.valueReal),
        expected_value: formatValue(action.margin.expenseExpectedReal),
        real_value: formatValue(action.margin.expenseReal),
        expire_fund: formatValue(action.margin.expireReal),
        margin: formatValue(action.margin.marginExpectedReal)
      }
    })
  }

  const getFiscalYears = async () => {
    const response = await fetchFiscalYears()
    const { data } = response
    //setFilters({...filters, fiscal_year: data[0].fiscal_year})
    setFiscalYears(data.map(({ fiscal_year }) => fiscal_year))
  }

  const fetchFiscalYears = () => {
    return api.get('company-rules/fiscal-years');
  }

  const exportData = async () => {
    setIsExport(true)
    const format = (table, fileName) => {
      return (`
      <html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel">
        <head>
          <!--[if gte mso 9]>
            <xml>
              <x:ExcelWorkbook>
                  <x:ExcelWorksheets>
                    <x:ExcelWorksheet>
                        <x:Name>${fileName || 'Worksheet'}</x:Name>
                        <x:WorksheetOptions>
                          <x:DisplayGridlines/>
                        </x:WorksheetOptions>
                    </x:ExcelWorksheet>
                  </x:ExcelWorksheets>
              </x:ExcelWorkbook>
            </xml>
          <![endif]-->
          <meta http-equiv="content-type" content="text/plain; charset=UTF-8"/>
        </head>
        <body>
          ${convertToAscii(ReactDOMServer.renderToString(table), [160])}
        </body>
      </html>`
      )
    }

    const buildTable = data => {
      return (
        <Table>
          <thead>
            {columns.map(col => (
              <th>{col.text}</th>
            ))}
          </thead>
          <tbody>
            {data.map(d => {
              return (
                <tr>
                  {columns.map(col => {
                    return (
                      <td>{d[col.dataField]}</td>
                    )
                  })}
                </tr>
              )
            })}
          </tbody>
        </Table>
      )
    }

    var _filters = {...filters}

    delete _filters.per_page
    delete _filters.page

    const response = await fetchActions(_filters)
    const { data } = response.data

    let table_div = format(buildTable(formatData(data, true)), "report_actions")
    var a = document.createElement('a')
    var data_type = 'data:application/vnd.ms-excel; charset=UTF-8'
    var table_html = escape(table_div)
    a.href = data_type + ', ' + table_html
    a.download = 'report_actions.xls'
    a.click();
    setIsExport(false)
  }

  return (
    <Card.Body className="shadow bg-white rounded mb-3">
      <Row>
        <Col className="d-flex mt-3 mb-3">
          <DashboardOutlined className="icon-title" />
          <h4 className="title-dashboard mt-2">Relatório de Ações</h4>
        </Col>
        <Col md="12" className="mb-2">
          <Button
            onClick={() => exportData()}
            disabled={isExport}
          >
            Exportar Tabela
            {' '}
            <Spinner
              animation="border"
              role="status"
              size="sm"
              style={!isExport ? { display: 'none' } : {}}
            />
          </Button>
        </Col>
      </Row>
      <Row>
        <Col>
          <Row>
            <Col>
              <ListingReportsActions
                data={actions}
                filters={[]}
                pagination={pagination}
                stateFilters={setFilters}
                handleFilterChange={handleFilterChange}
                load={load}
                fiscalYears={fiscalYears}
                taskGroups={taskGroups}
                statusList={statusList}
                columns={columns}
              />
            </Col>
          </Row>
        </Col>
      </Row>
    </Card.Body>
  )
}

export default MasterPage(Actions)